export const table = () => (
  <path
    d="M8.847 3v18m6-18v18m-12-12.152h18m-18 6.147h18M4.847 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
